import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const ClientHeaderContainer = styled.div`
  margin-top: 8px
  margin-left: -10px;
  display: flex;
  width: calc(100% + 30px);
  border-bottom: 1px solid ${colors.stroke['sub-300']};

  @media (max-width: 768px) {
    flex-direction: column;
    height: 424px;
  }

  @media (min-width: 769px) and (max-width: 1200px) {
    height: fit-content;
  }
`;

export const PictureContainer = styled.div`
  width: 278px;
  background-color: ${colors.brand.primary.lighter};
  height: 118px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    object-fit: contain;
    height: 120px;
    width: 278px;
  }
`;

export const InfoContainer = styled.div`
  margin: 16px;
  flex: 1;
  display: flex;
  gap: 32px;
  align-items: start;
  justify-content: flex-start;
  flex-wrap: wrap;

  & > button {
    height: 33px;
    width: 78px;
    white-space: nowrap;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ClientInfoContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  flex-wrap: wrap;

  @media (min-width: 769px) {
    flex-basis: 70%;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  height: 52px;

  & > h1 {
    margin: 0;
    flex: 1;
    font-weight: 700;
    font-size: 40px;
    line-height: 130%;
    color: ${colors.text['main-900']};
  }

  @media (max-width: 768px) {
    align-items: start;
    flex-direction: column;
    gap: 8px;
    height: auto;
  }

  @media (min-width: 769px) {
    flex-wrap: wrap;
    & > h1 {
      flex-basis: 70%;
    }
  }

  @media (min-width: 769px) and (max-width: 1200px) {
    height: fit-content;
  }


`;

export const AdditionalInfoContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;

  & > div {
    display: flex;
    align-items: center;
    gap: 4px;

    & > svg {
      margin: 2px 0;
    }

    & > span {
      font-weight: 400;
      text-size: 12px;
      line-height: 180%;
      color: ${colors.text['main-900']};
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;

  span {
    margin-top: 2px;
  }
`;

export const CNPJIcon = styled.div`
  width: 30px;
  height: 18px;
  color: ${colors.text['primary-base']};
  font-weight: 600;
  font-size: 11px;
  line-height: 180%;
`;
